import React, { PureComponent } from 'react';
import { NoticeBar, NavBar, Icon } from 'antd-mobile';
import styles from '../../index.less';

export const ReportNoticeBar = () => (
  <div className={styles['notice-bar']}>
    <NoticeBar icon={null}>提示：带宽利用率为评估报告(仅供参考)</NoticeBar>
  </div>
);
export class ReportHeaderNav extends PureComponent {
  render() {
    let mySelf = this;
    let { title, onBack, ...restProps } = mySelf.props;
    return (
      <>
        <NavBar
          mode="light"
          icon={onBack ? <Icon size="md" type="left" color="#000" /> : null}
          style={{ height: 42 }}
          onLeftClick={onBack}
          {...restProps}
        >
          {title}
        </NavBar>
      </>
    );
  }
}
